module.exports = __webpack_public_path__ + "static/media/avatar1.ff5ed06f.jpg";